import React from 'react';

import { Box } from '../../component-primitives/box';
import {
  SentimentNegativeIcon,
  SentimentSuccessIcon,
  SentimentWarningIcon,
} from './components';
import { useSentimentMessage } from './hooks/use-sentiment-message';
import { FormSentimentMessageProps } from './types';

export const FormSentimentMessage = ({
  children,
  type = 'error',
  isShowAlways = false,
  'data-test-id': dataTestId = 'error-message',
}: FormSentimentMessageProps) => {
  const { isVisible } = useSentimentMessage(type, isShowAlways);
  if (!isVisible) return null;
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      fontSize="sm"
      sx={{ mt: 3 }}
      gap="1"
      data-test-id={dataTestId}
    >
      {type === 'error' ? <SentimentNegativeIcon width={4} height={4} /> : null}
      {type === 'warning' ? (
        <SentimentWarningIcon width={4} height={4} />
      ) : null}
      {type === 'success' ? (
        <SentimentSuccessIcon width={4} height={4} />
      ) : null}
      {children}
    </Box>
  );
};
